"use client";
import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import CustomInput from "@/components/shared/CustomInput";
import Image from "next/image";
import search from "@/public/images/search.svg";
import Header from "@/components/shared/Header";
import Footer from "@/components/shared/Footer";
import TelegramLogin from "@/components/HomeComponents/TelegramLogin";
import AdPannerFooter from "@/components/shared/AdPannerFooter/AdPannerFooter";
import CourseCard from "@/components/shared/CourseCard";
import { useAppDispatch, useAppSelector } from "@/redux/store";
import USER, { SelectFullExams, SelectMyExams } from "@/redux/User";
import GENERAL, { SelectSchoolYears } from "@/redux/GENERAL";
import SocialMedia from "@/components/shared/socialMedia/SocialMedia";
import { usePathname, useRouter, useSearchParams } from "next/navigation";

const FullExamsPage: React.FC = () => {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();
  const dispatch = useAppDispatch();

  const exams = useAppSelector(SelectFullExams);
  // const myExams = useAppSelector(SelectMyExams);

  useEffect(() => {
    dispatch(GENERAL.thunks.doGetSchoolYears({}));
    // dispatch(USER.thunks.doGetMyExams({}));
  }, []);

  const [schoolYearSelected, setSchoolYearSelected] = useState<number[]>([]);
  const [searchValue, setSearchValue] = useState("");

  const schoolYear = useAppSelector(SelectSchoolYears);

  const schoolYearsIDs = searchParams
    .get("schoolyears_ids")
    ?.split("_")
    .map((el) => Number(el));

  useEffect(() => {
    schoolYearsIDs?.map((el) => {
      setSchoolYearSelected((prev) => [...prev, el]);
    });
  }, [schoolYear]);

  useEffect(() => {
    dispatch(
      USER.thunks.doGetFullExams({
        search: searchValue,
        school_years: schoolYearSelected,
      })
    );
  }, [schoolYearSelected, searchValue]);

  return (
    <div>
      <Header />
      <div className="container my-10 flex flex-col gap-10">
        <div className="bg-[#323538] rounded-[20px] p-3 flex flex-col gap-5">
          <div className="flex items-center bg-[#474A4D] rounded-[5px] py-2 pl-3">
            <Formik
              initialValues={{ search: "" }}
              onSubmit={(values) => {
                setSearchValue(values.search);
              }}
            >
              {(props) => (
                <Form className="w-full flex justify-between gap-4">
                  <CustomInput
                    type="text"
                    name="search"
                    placeholder="بحث عن كود في المنصة"
                    fullWidth={true}
                  />
                  <button type="submit">
                    <Image src={search as string} alt="search" />
                  </button>
                </Form>
              )}
            </Formik>
          </div>
          <div className="flex gap-5 flex-wrap">
            {schoolYear.map((year: any, i: number) => (
              <button
                onClick={() => {
                  if (schoolYearSelected.includes(year.id)) {
                    setSchoolYearSelected((prev) =>
                      prev.filter((item) => item !== year.id)
                    );
                    router.push(pathname);
                  } else {
                    setSchoolYearSelected((prev) => [...prev, year.id]);
                    router.push(pathname);
                  }
                }}
                className={
                  schoolYearSelected.includes(year.id)
                    ? "bg-primaryColor text-black"
                    : "bg-[#474A4D] text-white"
                }
                style={{
                  borderRadius: "5px",
                  fontSize: "14px",
                  padding: "12px 20px",
                }}
                key={i}
              >
                {year.name}
              </button>
            ))}
          </div>
        </div>
        {exams.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 place-content-center place-items-center">
            {[...exams].reverse()?.map((course: any, index: number) => (
              <CourseCard key={index} course={course} isFullExam={true} />
            ))}
          </div>
        ) : (
          <div className="text-center text-red-400 bg-[#474A4D] rounded-[5px] py-5 px-3">
            <p>لم يتم العثور على دورات بناءً على الفلاتر المطبقة.</p>
          </div>
        )}
        {/* <Pagination page={page} setPage={setPage} numberOfPages={10} /> */}
      </div>
      <SocialMedia />
      <Footer />
      <TelegramLogin />
      {/* <AdPannerFooter /> */}
    </div>
  );
};

export default FullExamsPage;
